import { render, staticRenderFns } from "./json-ld-organization.vue?vue&type=template&id=7f9ae0c0&"
import script from "./json-ld-organization.vue?vue&type=script&lang=js&"
export * from "./json-ld-organization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports